var _path, _path2, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 57,
    viewBox: "0 0 64 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 5.99999C0.75 3.1005 3.1005 0.75 6 0.75H43.3269C46.2264 0.75 48.5769 3.10051 48.5769 6V34.5577C48.5769 37.4572 46.2264 39.8077 43.3269 39.8077H19.4188C17.7034 39.8077 16.0128 40.2182 14.4884 41.005L2.57331 47.1548C1.74134 47.5842 0.75 46.9802 0.75 46.044V40.5577V5.99999Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7265 13.1538H56.481C59.7947 13.1538 62.481 15.8401 62.481 19.1538V48.6205V53.4776C62.481 55.03 60.7893 55.9905 59.4561 55.195L50.8054 50.0331C49.256 49.1086 47.4854 48.6205 45.6812 48.6205H27.2457C24.3062 48.6205 21.9233 46.2375 21.9233 43.298V43.298",
    stroke: "#263238",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.2114,
    y: 12.4038,
    width: 30,
    height: 3.69231,
    rx: 1.84615,
    fill: "#38BFF2",
    stroke: "#263238",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2114,
    y: 20.0769,
    width: 23.4231,
    height: 3.69231,
    rx: 1.84615,
    fill: "#38BFF2",
    stroke: "#263238",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.78d85de6b7ba70490f3b505568640605.svg";
export { ForwardRef as ReactComponent };